<template>
  <div class="movie-box ticket-wrapper" ref="ticket">
      <!-- 搜索 -->
      <div class="movie-box page-fixed movie-gradient ticket-search-wrapper">
          <MovieSearch @getSearchInfo="getSearchInfo" @clickCity="clickCity" :isClear="isClear" :city="currentCity" :placeholderText="''" :searchStyle="searchStyle"></MovieSearch>
      </div>
      
      <!-- 城市列表 -->
      <MovieCity :hide="hide" @changeCity="changeCity" :locationCity="currentCity"></MovieCity>

      <!-- 列表 -->
      <div class="pad30">
          <router-link class="acea-row ticket-card" v-for="(item, ind) in ticketList" :key="ind" :to="`/ticketDetail/${item.id}`">
              <div class="ticket-img-wrapper">
                  <img class="page-image" v-lazy="item.image_url" />
              </div>
              <div class="ticket-info-wrapper">
                  <h1 class="page-text-ellipsis-nowrap">{{item.name}}</h1>
                  <div class="margin-top ticket-time-wrapper">
                    <span class="font-color-red line1"><span class="distance-color">开放时间：</span>{{item.open_time_desc}}</span>
                  </div>
                  <div class="margin-top acea-row row-between-wrapper">
                    <span class="distance-color">
                        <i class="ticket-open-time iconfont icon-dizhi"></i>
                        {{item.distance}}km
                    </span>
                    <span class="distance-color">
                        <span class="font-color-red price-font-size">{{item.price}}</span>
                        起
                    </span>
                  </div>
              </div>
          </router-link>
          <div v-if="loaded && !failed" class="padtb20 page-text-center page-done-text-color">已加载完成</div>
          <Loading :loaded="loaded" :loading="loading"></Loading>
          <div class="page-margin-top3 page-text-center" v-if="ticketList.length === 0 && failed">
              没有查到诶╮(╯▽╰)╭
          </div>
      </div>
  </div>
</template>

<script>
import Loading from "@components/Loading";
import MovieSearch from "@components/MovieSearch";
import MovieCity from '@components/MovieCity.vue';
import { getTicketList } from "@api/ticket.js";
import cookie from "@utils/store/cookie";
import { wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { searchLocalCity, searchCityByLatLng } from "@libs/geolocation.js";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";

export default {
    name:"Ticket",
    components: {
        MovieSearch,
        Loading,
        MovieCity
    },
    data: function() {
        return {
            searchStyle: {
                'color': '#eee'
            },
            page: 1,
            limit: 10,
            keywords: "",
            currentCity: "北京",
            lat: cookie.get(LATITUDE) || 39.890588,
            lng: cookie.get(LONGITUDE) || 116.473892,
            ticketList: [
                // {
                //     name: '上海迪士尼度假区',
                //     id: 1,
                //     crtip_id: 1413493,
                //     open_time_desc: '4月18日-4月25日 08:30-21:30',
                //     distance: 1.6,
                //     latitude: "22.548039000",
                //     longitude: "114.070413000",
                //     price: "0.00",
                //     image_url: 'https://dimg01.c-ctrip.com/images/0106c120008jz4y6pAB51_R_1600_10000.jpg'
                // }
            ],
            loaded: false,
            loading: false,
            hide: false,  //城市列表开关
            isClear: false, //是否清空搜索栏
            failed: false, // 是否展示查询列表失败提示信息
            scrollY: 0
        }
    },
    mounted: function () {
        if(!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) {
            this.selfLocation();
        } else {
            this.getTicketDataList();
        }

        this.$scroll(this.$refs.ticket, this.getData, this.handle);
    },
    activated: function () {
        this.$nextTick(()=>{
            window.scrollTo(0, this.scrollY);
        });
    },
    methods: {
        handle: function (e) {
            let { scrollY } = e;
            this.scrollY = scrollY;
        },
        clickCity: function () {
            this.hide = true;
        },
        changeCity: function (val) {

            this.hide = false;

            if (val == this.currentCity) return;

            if (!this.isClear) {
                this.isClear = true;
            }
            this.currentCity = val;
            this.keywords = "";
            this.lat = cookie.get(LATITUDE) || "";
            this.lng = cookie.get(LONGITUDE) || "";
            this.page = 1;
            this.ticketList = [];
            this.loaded = false;
            this.loading = false;
            this.failed = false;
            this.$nextTick(()=>{
                this.getTicketDataList();
            });
        },
        getData: function () {
            !this.loading && this.getTicketDataList();
        },
        //
        selfLocation: function () {
            // console.log("判断环境");
            if (isWeixin()) {
                wxShowLocation().then((res)=>{
                    // console.log(res,"拿到坐标");
                    let lat = parseFloat(res.latitude);
                    let lng = parseFloat(res.longitude);
                    let city = "";

                    searchCityByLatLng(lat, lng).then((val) => {

                        let detail = val.detail.split(',')[1];
                        city = this.city_lostCompany(detail);
                    });
                    if (city) {
                        this.currentCity = city;
                    }
                    this.lat = lat;
                    this.lng = lng;
                        
                    this.$nextTick(()=>{
                        this.getTicketDataList();
                    });
                })
                .catch((err)=>{
                    console.log(err, "微信定位错误");
                    this.getTicketDataList();
                });
            } else {
                this.getTxmap();
            }
        },
        getTxmap: async function () {
            // console.log("h5去坐标");

            searchLocalCity().then((res)=>{
                let city = res.name; //城市
                let lat = parseFloat(res.latLng.lat); // 纬度
                let lng = parseFloat(res.latLng.lng); // 经度
                // console.log(city, lat, lng, "得到坐标");
                
                cookie.set(LATITUDE, lat);
                cookie.set(LONGITUDE, lng);
                
                if (city && lat && lng) {
                    this.currentCity = this.city_lostCompany(city);
                    this.lat = lat;
                    this.lng = lng;
                }
                this.$nextTick(()=>{
                    this.getTicketDataList();
                });

            }).catch((err)=>{
                this.$dialog.error(err);
                console.log(err);
                this.getTicketDataList();
            });

        },
        city_lostCompany: function (val) {
            if (val.indexOf('市') !== -1 ) {
                const values = val.split('');
                values.splice(values.indexOf('市'),1);
                const curCity = values.join('');
                return curCity;
            } else {
                return val;
            }
        },
        //
        getTicketDataList: async function () {
            if (this.loading || this.loaded ) return;
            let data = {
                area: this.currentCity,
                keyword: this.keywords || "",
                page: this.page,
                limit: this.limit,
                lat: this.lat || cookie.get(LATITUDE),
                lng: this.lng || cookie.get(LONGITUDE)
            };
            // console.log(data.page,"拿数据");
            this.loading = true;
            await getTicketList(data).then((res)=>{
                // console.log(res,"得到数据啦————————", this.ticketList);
                if (res.data.length !== 0) {

                    //环球影城
                    res.data && res.data.forEach(val => {
                        if (val.crtip_id == 2045497) {
                            let _open = val.open_time_desc.split(' ');//'全年 '+ _open[1] + _open[_open.length-1] + ' 周六周日 09:00-20:00'
                            val.open_time_desc = "全年 周一-周五10:00-19:00 周六日 09:00-20:00";
                        }
                    });

                   this.ticketList = this.ticketList.concat(res.data);
                   this.page++;
                }
                this.loaded = res.data.length < this.limit;
                this.loading = false;
                if (this.ticketList.length === 0) {
                       this.failed = true;
                }

            }).catch((err)=>{
                this.loading = false;
                console.log(err);
                this.$dialog.error(err.msg);
            });
        },
        getSearchInfo: function(val) {
            if (this.isClear) {
                this.isClear = false;
            }
            this.keywords = val;
            this.lat = cookie.get(LATITUDE) || "";
            this.lng = cookie.get(LONGITUDE) || "";
            this.page = 1;
            this.ticketList = [];
            this.loaded = false;
            this.loading = false;
            this.failed = false;
            this.$nextTick(()=>{
                 this.getTicketDataList();
            })
            
        }
    }
}
</script>

<style scoped>
.ticket-wrapper {
    padding-top: 1.1rem;
}
.ticket-search-wrapper{
    top: 0;
    left: 0;
    border-radius: 0 0 .5rem .5rem;
    z-index: 200;
}
.ticket-img-wrapper {
    width: 2.3rem;
    height: auto;
    margin-right: .2rem;
}
.ticket-img-wrapper img {
    border-radius: .2rem;
}
.ticket-card {
    min-height: 2.16rem;
    padding-top: .2rem;
    padding-bottom: .2rem;
    border-bottom: .02rem solid #eee;
}
.ticket-card:last-child {
    border-bottom: none;
}
.ticket-info-wrapper {
    flex: 1;
    overflow: hidden;
}
.ticket-info-wrapper h1 {
    font-size: .3rem;
}
.ticket-time-wrapper {
    line-height: .34rem;
}
.margin-top {
    margin-top: .1rem;
}
.ticket-open-time {
    color: #ccc;
}
.distance-color {
    color: #999;
}
.price-font-size {
    font-size: .38rem;
}
</style>
